import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess } from '../../../redux/authSlice';
import { createAxios } from '../../../createInstance';
import { useNavigate } from 'react-router-dom';

import styles from './DefaultLayout.module.scss';
import classNames from "classnames/bind";
import Header from "../components/Header";

import { logOut } from '../../../redux/apiRequest';

const cx = classNames.bind(styles);

function DefaultLayout({ children }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.auth.login.currentUser);

    const usertest = {
        name: "Nguyễn Văn A",
        avatar: null
    };

    const handleLogout = () => {
        if (!user) {
            return navigate('/login')
        };
        const axiosJWT = createAxios(user, dispatch, loginSuccess, navigate);
        logOut(dispatch, navigate, user.accessToken, axiosJWT, user.refreshToken);
    };

    return (
        <div className={cx("container")}>
            <div className={cx('default-layout')}>
                <Header
                    user={user}
                    onLogout={() => handleLogout()}
                    onSettings={() => alert("Đi tới cài đặt")}
                />
                <div className={cx('wrap')}>
                    <div className={cx('wrap-child')}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DefaultLayout;